import {FETCH_TYPES, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS, GAMECONF_PARAMS} from "../../system/SystemConfig";
import InitResult from "../result/InitResult";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";

@injectable()
export default class ConnectAjaxInit extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.INIT;
    timeout: number = 20000;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {

        super(config, control, fetch, dom);

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).init > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).init * 1000;
        }

        this.setMethod(this.config.get(CONFIG_PARAMS.URL_INIT_METHOD));
    }

    async fetch(data) {
        this.control.reset();
        this.data = data;

        let res;

        try {
            res = await this._fetch();
        } catch (e) {
            return await Promise.reject(e);
        }

        return new InitResult(res.data);
    }

    getParams() {

        let language = this.config.get(CONFIG_PARAMS.LANGUAGE) || undefined;
        let skin = this.config.get(CONFIG_PARAMS.PLAYTECH_SKIN) || undefined;
        let channelType = this.config.get(CONFIG_PARAMS.PLAYTECH_CHANNEL_TYPE) || undefined;
        let clientPlatform = this.config.get(CONFIG_PARAMS.PLAYTECH_CLIENT_PLATFORM) || undefined;
        let clientType = this.config.get(CONFIG_PARAMS.PLAYTECH_CLIENT_TYPE) || undefined;
        let accountId = this.config.get(CONFIG_PARAMS.PLAYTECH_ACCOUNT_ID) || undefined;

        return {
            mode: this.data.mode,
            currency: this.data.currency,
            game_id: this.data.gameId,
            casino_id: this.data.casinoId,
            player_id: this.data.playerId != null ? this.data.playerId : undefined,
            session_key: this.data.sessionKey != null ? this.data.sessionKey : undefined,
            language: language,
            skin: skin,
            channeltype: channelType,
            clientplatform: clientPlatform,
            clienttype: clientType,
            account_id: accountId,
            device: this.data.device
        };
    }

    getUrl() {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_INIT), {
            "server_api": this.data.serverApi,
            "casino_id": this.data.casinoId,
            "game_id": this.data.gameId
        });
    }
}